import {I18nextProvider, initReactI18next, withTranslation} from "react-i18next";
import i18next from "i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

import en from "./en.json";
import de from "./de.json";

i18next.use(LanguageDetector)
    .use(initReactI18next)
    .init({
            resources: {
                en: en,
                de: de
                },
            lng: "en",
            fallbackLng: "en",
            whitelist: ["en", "de"],
            keySeparator: false,
            interpolation: {
                escape:false
                }
            });

export default i18next;
